<template>
  <span v-if="text">
    <span
      v-if="isTruncated"
      v-tippy="{
        content: text,
        maxWidth: tooltipMaxWidth,
        placement: tooltipPlacement
      }"
      class="truncated-text"
    >{{ truncatedText }}</span>
    <span v-else>{{ text }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue"

interface Props {
  text?: string
  length?: number
  tooltipMaxWidth?: number
  tooltipPlacement?: "top" | "bottom" | "left" | "right"
}

const props = withDefaults(defineProps<Props>(), {
  text: "",
  length: 16,
  tooltipMaxWidth: 350,
  tooltipPlacement: "top"
})

const isTruncated = computed(() => props.text.length >= props.length)

const truncatedText = computed(() =>
  props.text.substring(0, props.length) + (isTruncated.value ? "..." : "")
)
</script>

<style scoped>
.truncated-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
</style>
